var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoAttachmentsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 102,
    viewBox: "0 0 100 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.2967,
    cy: 39.9464,
    r: 35.0128,
    fill: "#EAECF0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.264,
    cy: 17.7279,
    r: 3.36662,
    fill: "#F2F4F7"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.24396,
    cy: 74.2875,
    r: 4.71326,
    fill: "#F2F4F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.756,
    cy: 28.5004,
    r: 4.71326,
    fill: "#F2F4F7"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.3494,
    cy: 10.3202,
    r: 2.69329,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2495_152734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.2967 25.1765L51.3509 23.8972L48.2971 25.1982V61.6214L76.4391 49.8286V13.3891L76.5763 13.3316L76.4391 13.2708V13.2096L76.3687 13.2396L48.5188 0.894531L20.0172 13.0355L20.1521 13.0934L20.0172 49.3849L48.2967 61.5997L48.2967 25.1765Z",
    fill: "#F9FAFB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2967 25.1768V61.6L20.0172 49.3852L20.1521 13.0938L48.2967 25.1768Z",
    fill: "url(#paint0_linear_2495_152734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2972 25.1975V61.6207L76.4392 49.8279V13.209L48.2972 25.1975Z",
    fill: "url(#paint1_linear_2495_152734)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2967 25.1765L76.5763 13.3316L48.5188 0.894531L20.0172 13.0355L48.2967 25.1765Z",
    fill: "#F2F4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6775 8.49442L58.8492 20.7565L59.1051 29.6923L66.9872 26.4399L66.7489 17.4478L37.7437 5.48438L30.6775 8.49442Z",
    fill: "#EAECF0"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2495_152734)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32.137,
    y: 46.6797,
    width: 32.3195,
    height: 32.3195,
    rx: 16.1598,
    fill: "#344054",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 62V68M45 65H51M58 70C58 70.5304 57.7893 71.0391 57.4142 71.4142C57.0391 71.7893 56.5304 72 56 72H40C39.4696 72 38.9609 71.7893 38.5858 71.4142C38.2107 71.0391 38 70.5304 38 70V56C38 55.4696 38.2107 54.9609 38.5858 54.5858C38.9609 54.2107 39.4696 54 40 54H45L47 57H56C56.5304 57 57.0391 57.2107 57.4142 57.5858C57.7893 57.9609 58 58.4696 58 59V70Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2495_152734",
    x: 0.0171509,
    y: 0.894531,
    width: 96.5591,
    height: 100.727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2495_152734"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2495_152734"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_2495_152734"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2495_152734",
    result: "effect2_dropShadow_2495_152734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2495_152734",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2495_152734",
    x: 24.137,
    y: 38.6797,
    width: 48.3195,
    height: 48.3203,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2495_152734"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2495_152734",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2495_152734",
    x1: 20.0172,
    y1: 49.5683,
    x2: 31.1856,
    y2: 19.3213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE1E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFF1F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2495_152734",
    x1: 48.2968,
    y1: 25.9104,
    x2: 80.1846,
    y2: 32.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F4F7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAttachmentsIcon);
export default __webpack_public_path__ + "static/media/NoAttachmentsIcon.42fda8a55c8a92757d9f35a75c6af7c3.svg";
export { ForwardRef as ReactComponent };